import type { Project, SimpleProject } from '@meego/models/src/types/base';
import type { DisplayMode } from '@meego/utils/src/styles';
import type { RealLanguage } from '@meego/platform/src/language';
import type { FeatureGateKeys } from '@meego/models/src/types/featureGateKeys';
import type { ResetFilterOption } from '@meego/view/src/store/StoryViewNew/Stores/quickFilter/_type';
import type { WorkItemPreference } from '@meego/work-item/src/pages/workItemDetail/stores';
import type { DrawerLocation } from '@meego/biz-utils/src/router/store/drawerRouterStore';
import type { ComparisonContentType } from '@meego/models/src/types/WBS';
import type { WorkItemTypeMap } from '@meego/work-item/src/pages/workItemCreate/hooks/useMemorizedActiveTypeKey';
export const LOCALSTORAGE_DB_NAME = 'MissionLocalData';
export const LOCALSTORAGE_INTER_PROJECT_DB_NAME = 'InterProjectLocalData';
export const LOCALSTORAGE_WORKSHEET_DB_NAME = 'WorksheetLocalData';
export const LOCALSTORAGE_MEEGO_TOKEN = 'meego_token';
export const LOCALSTORAGE_MOBILE_REDIRECT = 'mobile_redirect';
export const LOCALSTORAGE_STARLING_CASH_KEY = 'starling_cache';
export const LOCALSTORAGE_NEW_WORKBENCH_CONFIG = 'newWorkbenchConfig';
export const LOCALSTORAGE_NAV_UNFOLD_ITEMS = 'nav-unfold-items';
export const LOCALSTORAGE_LOGIN_TOKEN_INFO = 'loginTokenInfo';
export const LOCALSTORAGE_SHOW_FEEDBACK_GIFT_V1 = 'show_feedback_gift_v1';
export const LOCALSTORAGE_LATEST_MEEGO_PROJECT = 'latest_meego_project';
export const LOCALSTORAGE_LATEST_MEEGO_PROJECT_KEY = 'latest_meego_project_key';
export const LOCALSTORAGE_H5_DEFAULT_CREATE_PROJECT_MIIGO = 'h5_default-create-project_miigo';
export const LOCALSTORAGE_DEFAULT_CREATE_PROJECT_IN_WORKBENCH =
  'default-create-project-in-workbench';
export const LOCALSTORAGE_HAS_AUTO_SET_CHART_NAV = 'has_auto_set_chart_nav';
export const LOCALSTORAGE_APPROVAL_INFO = 'approval_info';
export const LOCALSTORAGE_MISSION_TOKEN = 'mission_token';
export const LOCALSTORAGE_NODE_CRASH_PROTECTION = 'node_crash_protection';

// 用于存储当前用户可以访问通那个 tos region  - 目前有 cn sg 和 us
export const LOCALSTORAGE_TOS_REGION = 'tos_region';
export const LOCALSTORAGE_lOGIN_ORIGIN_URL = 'login-origin-url';
export const LOCALSTORAGE_LEOPARD_DEFAULT_PROJECT = 'leopard-default-project'; // ？？？？？？？
export const LOCALSTORAGE_HELP_CENTER_SEARCH_RECORD = 'help_center_search_record';
export const LOCALSTORAGE_LABLAST_REVIEW_TIME = 'labLastReviewTime';
export const LOCALSTORAGE_SWITCH_TENANT_INFO = 'switch-tenant-info';
export const LOCALSTORAGE_RESOURCE_FAILED_RETRY = 'resource_failed_retry_with_path';
export const LOCALSTORAGE_PLAN_INFO_RELATE_TEMPLATES = 'plan_info_relate_templates';
export const LOCALSTORAGE_LANG = 'lang';
export const LOCALSTORAGE_VERSION_REFRESH_TIME = 'version_refresh_time';
export const LOCALSTORAGE_WBS_DEPEND_PATTERN_CONFIRM = 'wbs_depend_pattern_confirm';
export const LOCALSTORAGE_FG_MOCK_DATA = 'fg_mock_data';
export const LOCALSTORAGE_RELATION_NO_DATA_CHECKED = 'relation_no_data_checked';
export const LOCALSTORAGE_CUSTOM_COLOR_THEME = 'custom_color_theme';
export const LOCALSTORAGE_CUSTOM_COLOR_THEME_HIDE_NAVI_BUTTON_TEXT =
  'custom_color_theme_hide_navi_button_text';
export const AUTOMATION_RULE_INIT = 'automation_rule_init';
export const HIDE_SATISFACTION_SURVEY_CARD = 'hide_satisfaction_survey_card';
export const SURVEY_TIMES = 'survey_times_v25';
export const TRIGGER_SUB_NAV = 'trigger_sub_nav';
export const LOCALSTORAGE_COLOR_MODE = 'color_mode';
export const METRICS_MAIN_PAGE_MODE = 'metrics_main_page_mode';
export const SUB_NAV_WIDTH = 'sub_nav_width';
export const SYNC_TO_NODE_OWNERS = 'sync_to_node_owners';
export const IS_IN_TAG_COLOR_GREY = 'is_in_tag_color_grey';
export const SECOND_NAV_LOCAL_DATA = 'second_nav_local_data';
export const LOCALSTORAGE_PLUGIN_DEBUG_SWITCH = 'plugin_debug_switch';
export const INTERNALSETTINGS_PLATFORM_CONFIG = 'internal_settings_platform_config';
export const LOCALSTORAGE_USER_RECOMMEND_LIST = 'user_recommend_list';
export const COLLECT_PIN_LOCAL_DATA = 'collect_pin_local_data';
export const CUR_NO_AUTH_PROJECT_INFO = 'curNoAuthProjectInfo';
export const LOCALSTORAGE_MAIN_FILTER_RESET_OPTION = 'localstorage_main_filter_reset_option';
export const LOCALSTORAGE_THRESHOLD_HINT_FATIGUE = 'localstorage_threshold_hint_fatigue';
export const LOCALSTORAGE_USER_PREFERENCE_UPLOADED = 'localstorage_user_preference_uploaded';
export const LOCALSTORAGE_MEEGO_WORKITEM_PREFERENCE = 'meego_workItem_perference';
export const ADMIN_ENTER_SETTING_NOTIFIED = 'admin_enter_setting_notified';
export const LOCAL_TABLE_VIEW = 'local_table';
export const DRAWER_FULL_TYPE = 'drawer_full_type';
export const DRAWER_HISTORY = 'drawer_history';
export const DRAWER_TRIGGER_SUB_NAV = 'drawer_trigger_sub_nav';
export const DRAWER_TRIGGER_SUB_NAV_ORIGIN = 'drawer_trigger_sub_nav_origin';
export const I18N_SYNC_OPEN_NO_REMIND = 'i18n_sync_open_no_remind';
export const I18N_SYNC_CLOSE_NO_REMIND = 'i18n_sync_close_no_remind';
export const LOCALSTORAGE_CACHE_TRANSLATIONS = 'localstorage_cache_translations';
export const LOCALSTORAGE_CACHE_SYNC = 'localstorage_cache_sync';

export const HSR_TIMMING_PATH = 'timming_hsr';

export const LOCAL_WBS_SHOW_DEPENDENCY_RELATION = 'wbs_show_dependency_relation';

export const LOCAL_WBS_SHOW_KEY_PATH = 'wbs_show_key_path';

export const LOCAL_WBS_SCHEDULE_TABLE_COLUMNS_WIDTH = 'local_wbs_schedule_table_columns_width';

export const LOCAL_WBS_SCHEDULE_TABLE_EXPAND_LEVEL = 'local_wbs_schedule_table_expand_level';

export const NEED_CREATE_BASELINE = 'need_create_baseline';
export const SELECTED_COMPARISON_CONTENT_TYPE = 'selected_comparison_content_type';
export const LOCALSTORAGE_SEARCH_TABS = 'localstorage_search_tabs';
export const LOCALSTORAGE_GROUP_OUTLINE = 'localstorage_group_outline';
export const LOCALSTORAGE_INBOX_MSG_ID = 'localstorage_inbox_msg_id'; // 修复打开多个页面通知重复问题，存储msg_id
export const HARDWARE_DISPLAY = 'hardware_display';
export const VIEW_UNCHECKED_PAGE_VIEW = 'view_unchecked_page_view';
export const PRICING_TO_ENTERPRISE = 'pricing_to_enterprise';
export const PREVENT_LISTEN_PERMISSION_COLLIPSE_EVENT = 'prevent_listen_permission_collipse_event';
export const RGPARK_CHECK_CONTINUE_TOAST_STOP = 'rgpark_check_continue_toast_stop';
export const LOCALSTORAGE_CURRENT_WORKSPACE = 'localstorage_current_workspace';
export const LOCALSTORAGE_CURRENT_WORKSPACE_KEY = 'localstorage_current_workspace_key';
export const LOCALSTORAGE_CLIENT_IP = 'localstorage_client_ip';
export const LOCALSTORAGE_VIEW_SPEED_MODE_TIP_VISITED = 'localstorage_view_speed_mode_tip_visited';

export const LOCALSTORAGE_TENANT_CONFIG = 'tenant_config'; // 租户配置
export const LOCALSTORAGE_WORKITEM_CREATE_TYPE = 'localstorage_workitem_create_type';

type ProjectSimpleName = string;

export type StorageType = {
  [HARDWARE_DISPLAY]: boolean;
  [LOCALSTORAGE_GROUP_OUTLINE]: {
    [props: string]: boolean;
  };
  [AUTOMATION_RULE_INIT]: number;
  [LOCALSTORAGE_TOS_REGION]: string;
  [LOCALSTORAGE_LATEST_MEEGO_PROJECT]: string;
  [LOCALSTORAGE_LATEST_MEEGO_PROJECT_KEY]: string;
  [LOCALSTORAGE_HAS_AUTO_SET_CHART_NAV]: string;
  [LOCALSTORAGE_MOBILE_REDIRECT]: string;
  [LOCALSTORAGE_DEFAULT_CREATE_PROJECT_IN_WORKBENCH]: {
    // 租户key
    tenant_key: string;
    // 资产key
    asset_key: string;
    // 空间key
    project_key: string;
  };
  [LOCALSTORAGE_MEEGO_TOKEN]: string;
  [LOCALSTORAGE_STARLING_CASH_KEY]: {
    [key: string]: string;
  };
  [LOCALSTORAGE_NAV_UNFOLD_ITEMS]: Record<ProjectSimpleName, string>;
  [LOCALSTORAGE_NEW_WORKBENCH_CONFIG]: {
    main: string[];
    pendant: string[];
    pendentType: string;
    showList: string;
    showPendant: boolean;
    showType: string;
  };
  [LOCALSTORAGE_lOGIN_ORIGIN_URL]: string;
  [LOCALSTORAGE_LEOPARD_DEFAULT_PROJECT]: Project | SimpleProject | undefined;
  [LOCALSTORAGE_HELP_CENTER_SEARCH_RECORD]: Array<string>;
  [LOCALSTORAGE_SHOW_FEEDBACK_GIFT_V1]: string;
  [LOCALSTORAGE_H5_DEFAULT_CREATE_PROJECT_MIIGO]: Pick<
    SimpleProject,
    '_id' | 'name' | 'simple_name'
  >;
  [LOCALSTORAGE_LABLAST_REVIEW_TIME]: string;
  [LOCALSTORAGE_SWITCH_TENANT_INFO]: {
    userName: string;
    tenantName: string;
  };
  [LOCALSTORAGE_RESOURCE_FAILED_RETRY]: {
    path: string;
    retryTimes: number;
  };
  [LOCALSTORAGE_PLAN_INFO_RELATE_TEMPLATES]: Array<string>;
  [LOCALSTORAGE_APPROVAL_INFO]: {
    [key: string]: any;
  };
  [LOCALSTORAGE_LOGIN_TOKEN_INFO]:
    | {
        expire_time: number;
        refresh_token: string;
        need_update_email?: boolean;
      }
    | undefined;
  [LOCALSTORAGE_MISSION_TOKEN]: string;
  [LOCALSTORAGE_NODE_CRASH_PROTECTION]: number;
  [LOCALSTORAGE_WORKSHEET_DB_NAME]: any;
  [LOCALSTORAGE_INTER_PROJECT_DB_NAME]: any;
  [LOCALSTORAGE_LANG]: 'zh' | 'en' | 'ja';
  [LOCALSTORAGE_VERSION_REFRESH_TIME]: number;
  [LOCALSTORAGE_WBS_DEPEND_PATTERN_CONFIRM]: boolean | undefined;
  [LOCALSTORAGE_FG_MOCK_DATA]: Partial<Record<FeatureGateKeys, boolean>>;
  [LOCALSTORAGE_RELATION_NO_DATA_CHECKED]: boolean | undefined;
  [HIDE_SATISFACTION_SURVEY_CARD]: boolean | undefined;
  [SURVEY_TIMES]: number | undefined;
  [LOCALSTORAGE_COLOR_MODE]: DisplayMode;
  [SYNC_TO_NODE_OWNERS]: boolean | undefined;
  [INTERNALSETTINGS_PLATFORM_CONFIG]: Record<string, boolean>;
  // 历史 starling
  'text.a7f5ae30013211ea99f1f3e87f7ab1bd.i18n.en': string;
  'version.a7f5ae30013211ea99f1f3e87f7ab1bd.i18n.en': string;
  [IS_IN_TAG_COLOR_GREY]: 0 | 1;
  [LOCALSTORAGE_PLUGIN_DEBUG_SWITCH]: boolean | undefined;
  [LOCALSTORAGE_USER_RECOMMEND_LIST]: Array<{
    key: string;
    data: any;
  }>;
  [I18N_SYNC_OPEN_NO_REMIND]: boolean | undefined;
  [I18N_SYNC_CLOSE_NO_REMIND]: boolean | undefined;
  [TRIGGER_SUB_NAV]: boolean;
  [METRICS_MAIN_PAGE_MODE]: number | undefined;
  [SUB_NAV_WIDTH]: number;
  [SECOND_NAV_LOCAL_DATA]: {
    [username: string]: {
      favorite?: {
        expandedKeys?: string[];
        scopeExpanded?: boolean;
        selectedNode?: Object;
      };
      collaporation?: {
        [projectKey: string]: {
          selectedNode?: Object;
          share?: {
            expandedKeys?: string[];
            scopeExpanded?: boolean;
          };
          personal?: {
            expandedKeys?: string[];
            scopeExpanded?: boolean;
          };
        };
      };
    };
  };
  [COLLECT_PIN_LOCAL_DATA]: {
    personalExpanded: boolean;
    favoriteExpanded: boolean;
  };
  [LOCALSTORAGE_CACHE_SYNC]: Array<{
    uniqueKey: string;
    language: RealLanguage;
    sync: string;
  }>;
  [LOCALSTORAGE_CACHE_TRANSLATIONS]: Array<{
    uniqueKey: string;
    translations: Array<{
      language: RealLanguage;
      translation: string;
    }>;
  }>;
  [LOCALSTORAGE_PLUGIN_DEBUG_SWITCH]: boolean | undefined;
  homepage_statistics: { [key: string]: number };
  [CUR_NO_AUTH_PROJECT_INFO]: SimpleProject;
  [LOCALSTORAGE_USER_PREFERENCE_UPLOADED]: boolean;
  [LOCALSTORAGE_MEEGO_WORKITEM_PREFERENCE]: WorkItemPreference;
  [LOCALSTORAGE_MAIN_FILTER_RESET_OPTION]: ResetFilterOption;
  [ADMIN_ENTER_SETTING_NOTIFIED]: { [key: string]: boolean };
  [LOCAL_TABLE_VIEW]: any;
  [DRAWER_FULL_TYPE]: { [key: string]: string };
  [DRAWER_HISTORY]: { [key: string]: DrawerLocation[] };
  [DRAWER_TRIGGER_SUB_NAV]: { [key: string]: boolean };
  [DRAWER_TRIGGER_SUB_NAV_ORIGIN]: boolean;
  [LOCALSTORAGE_CUSTOM_COLOR_THEME]: string;
  [LOCALSTORAGE_CUSTOM_COLOR_THEME_HIDE_NAVI_BUTTON_TEXT]: boolean;
  homepage_tab_data: {
    [key: string]: {
      [key: string]: {
        firstTab?: string;
        secondTab?: string;
        isSynced?: boolean;
        tabHistoryMap?: Record<string, string | undefined>;
      };
    };
  };
  [LOCAL_WBS_SHOW_KEY_PATH]: boolean;
  [LOCAL_WBS_SHOW_DEPENDENCY_RELATION]: boolean;
  [LOCAL_WBS_SCHEDULE_TABLE_COLUMNS_WIDTH]: Record<string, Record<string, number>>;
  [LOCAL_WBS_SCHEDULE_TABLE_EXPAND_LEVEL]: Record<string, 'all' | 1 | 2 | 3 | 4 | 5 | 6>;
  [NEED_CREATE_BASELINE]: boolean | undefined;
  [SELECTED_COMPARISON_CONTENT_TYPE]: ComparisonContentType[] | undefined;
  [HSR_TIMMING_PATH]: { [time: number]: string };
  [LOCALSTORAGE_SEARCH_TABS]: Array<{
    tab_type: number;
    search_tab_cfgs: [{ [key: string]: string | number }];
  }>;
  [LOCALSTORAGE_CLIENT_IP]: {
    value: string;
  };
  [VIEW_UNCHECKED_PAGE_VIEW]: Record<string, string[]> | undefined;
  [PRICING_TO_ENTERPRISE]: string;
  [PREVENT_LISTEN_PERMISSION_COLLIPSE_EVENT]: boolean;
  [LOCALSTORAGE_VIEW_SPEED_MODE_TIP_VISITED]: boolean;
  [LOCALSTORAGE_WORKITEM_CREATE_TYPE]: WorkItemTypeMap[];
} & {
  [key in `${string}_translate_toast`]: boolean;
} & {
  [key in `continuous_create_${string}`]: boolean;
};

type ModeType = 'visit' | 'modify';

export const LRULocalStorageConfig: Record<
  keyof StorageType,
  {
    mode: ModeType;
    size: number;
  }
> = {} as any;
